import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export const generatePDF = async ({ heading1, heading2, heading3, heading4, headerEnglishColumns, pdfData, width, PDFFileName, highlightedRowIndexes = [] }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // Calculate number of columns dynamically
    const numColumns = width && width.length > 0 ? width.length : (headerEnglishColumns ? headerEnglishColumns.length : 12);
    
    // Debug logs
    console.log('PDF Generation Debug:', {
        numColumns,
        headerEnglishColumnsLength: headerEnglishColumns ? headerEnglishColumns.length : 0,
        headerEnglishColumns: headerEnglishColumns,
        widthLength: width ? width.length : 0,
        pdfDataLength: pdfData ? pdfData.length : 0,
        firstRowLength: pdfData && pdfData[0] ? pdfData[0].length : 0,
        firstRowData: pdfData && pdfData[0] ? pdfData[0] : null
    });

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        (() => {
                            // Create heading row with colSpan and empty cells
                            const heading1Row = [{ text: heading1, style: 'header', colSpan: numColumns, alignment: 'center' }];
                            for (let i = 1; i < numColumns; i++) {
                                heading1Row.push({});
                            }
                            return heading1Row;
                        })(),
                        (() => {
                            // Create heading row with colSpan and empty cells
                            const heading2Row = [{ text: heading2, style: 'subheader_one', colSpan: numColumns, alignment: 'center' }];
                            for (let i = 1; i < numColumns; i++) {
                                heading2Row.push({});
                            }
                            return heading2Row;
                        })(),
                        (() => {
                            // Create heading row with colSpan and empty cells
                            const heading3Row = [{ text: heading3, style: 'subheader_two', colSpan: numColumns, alignment: 'center' }];
                            for (let i = 1; i < numColumns; i++) {
                                heading3Row.push({});
                            }
                            return heading3Row;
                        })(),
                        (() => {
                            // Create heading row with colSpan and empty cells
                            const heading4Row = [{ text: heading4, style: 'subheader_three', colSpan: numColumns, alignment: 'center' }];
                            for (let i = 1; i < numColumns; i++) {
                                heading4Row.push({});
                            }
                            return heading4Row;
                        })(),
                        (() => {
                            // Ensure header row has exactly numColumns cells
                            const headerRow = [];
                            for (let i = 0; i < numColumns; i++) {
                                headerRow.push({
                                    text: (headerEnglishColumns && headerEnglishColumns[i]) ? String(headerEnglishColumns[i]) : '',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 15,
                                });
                            }
                            return headerRow;
                        })(),
                        ...pdfData.map((row, rowIndex) => {
                            // Ensure each row has exactly numColumns cells
                            if (!row || !Array.isArray(row)) {
                                return Array(numColumns).fill({ text: '', fontSize: 12, bold: true, alignment: 'center' });
                            }
                            const shouldHighlightRow = highlightedRowIndexes.includes(rowIndex);
                            const paddedRow = [];
                            for (let i = 0; i < numColumns; i++) {
                                paddedRow.push({
                                    text: (row[i] !== undefined && row[i] !== null) ? String(row[i]) : '',
                                    fontSize: 12,
                                    bold: true,
                                    alignment: 'center',
                                    fillColor: shouldHighlightRow ? '#FFF59D' : undefined,
                                });
                            }
                            return paddedRow;
                        }),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            },
            subheader_three: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};
